<app-modal [active]="batchStarted" (modalClosed)="batchStarted = false">
  <app-batch-download></app-batch-download>
</app-modal>

<div style="background-color: #f7f7f7; padding: 2rem">

  <div class="columns" style="margin-bottom: 2rem">
    <div class="column is-2"></div>
    <div class="column" style="color: #35566E; font-size: 23px">Meine Bestellungen</div>
    <div class="column is-4"></div>
    <div class="column search">
      <div class="columns">
        <div class="column">
           <span>
             <input (keyup)="searchPagination()" [(ngModel)]="searchText" class="input" placeholder="Suche"
                        style="width: 150px; border-bottom: none !important;background-color: #ffffff"
                        type="text">
           </span>
        </div>
        <div class="column">
          <span style="float: right; padding: 8px">
            <svg height="24.093" viewBox="0 0 29.086 29.093" width="24.086" xmlns="http://www.w3.org/2000/svg">
              <path d="M33.245,31.481l-8.089-8.165a11.528,11.528,0,1,0-1.75,1.772L31.442,33.2a1.245,1.245,0,0,0,1.757.045A1.253,1.253,
                0,0,0,33.245,31.481ZM16.1,25.186a9.1,9.1,0,1,1,6.438-2.666A9.047,9.047,0,0,1,16.1,25.186Z" data-name="Icon ionic-ios-search"
                fill="#707070"
                id="Icon_ionic-ios-search" transform="translate(-4.5 -4.493)"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="column"></div>
  </div>
  <ng-container *ngIf="this.hasViewPermissions(); else noPermissions">
    <div *ngIf="order?.properties" class="columns">
      <div class="column is-2"></div>
      <div class="column" style="border-radius: 15px; border-top: none; height: 100%; background-color: #ffffff ">
        <div class="columns"
             style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
          <div class="column is-narrow pl-5 is-flex is-justify-content-center is-align-items-center">
            <a class="is-clickable color-white" routerLink="/order">
                <fa-icon [icon]="faArrowLeft"></fa-icon>
            </a>
            <span class="ml-5" style="vertical-align: middle">Auftrag {{order.orderid}}</span>
          </div>
        </div>
          <div class="columns mt-4">
              <div class="column is-4 pl-5">
                <p class="is-size-6 has-text-grey">Bestelldatum: {{order.entrydate | date:'dd.MM.yyyy'}}</p>
                <p class="is-size-6 has-text-grey truncate" appTooltip matTooltip="Aufgegeben von: {{order.orderStatistics?.orderedByUserName ?? 'Besteller unbekannt'}}" *ngIf="order.orderStatistics">Aufgegeben von: {{order.orderStatistics?.orderedByUserName ?? 'Besteller unbekannt'}}</p>
                <p class="is-size-6 has-text-grey">{{order.properties.length}} Objekt/e</p>
              </div>
              <div class="column is-4">
                  <h6 class="title is-4 color-darkblue is-bold has-text-centered does-not-wrap">Auftragsfortschritt</h6>
              </div>
              <div class="columns is-4"></div>
          </div>
        <app-pagination (goTo)="onGoTo($event)"
                        (next)="onNext($event)"
                        (previous)="onPrevious($event)"
                        *ngIf="total > 1"
                        [current]="current"
                        [total]="total"
        ></app-pagination>
        <div *ngIf="(order.properties | search: searchText: 'orderDetailsProperty').length === 0"
             class="has-text-centered">
          Kein Ergebnis. Zurück zur <a routerLink="/order">Bestellübersicht</a> ?
        </div>

        <div class="grid-container mt-5 mb-5">

          <div *ngFor="let property of itemsToDisplay | search: searchText: 'orderDetailsProperty'; let i = index"
               [ngClass]="{'is-invisible' : i >= 120}"
               class="property-details has-text-centered is-flex is-justify-content-center is-align-items-center is-flex-direction-column">
            <div class="order has-text-centered"></div>

            <div *ngIf="property.status === 'CANCELED'">
              <p class="is-bold" style="color: rgba(255,0,0,0.5)">Storniert</p>
            </div>

              <div [state]="[property, order]" (click)="cancelPropertyStatisticRequests()" routerLink="/order_object/{{property.id}}"
                   class="property-card is-clickable card has-round-border p-3" style="min-height: 320px; max-height: 320px; height: 100%; display: flex; flex-direction: column; justify-content: space-between">

                  <div>
                      <img *ngIf="containsDocumentWithUnseenInformation(property)" alt="Info Icon" src="assets/images/InfoIcon/info_icon_present.svg">
                  </div>

                  <div *ngIf="isActionRequired(property)" class="card has-round-border is-bold mb-4 background-light-red color-white">
                      <p [state]="[property, order]" class="is-clickable" routerLink="/order_object/{{property.id}}">Aktion
                          erforderlich</p>
                  </div>

                  <div class="color-darkblue is-size-6 mb-1" >
                      <p matTooltip="{{property.name}}" appTooltip class="truncate" *ngIf="property.name">
                          {{property.name}}
                      </p>
                      <p matTooltip="{{property.street + ' ' + (property.house_number ?? '')}}" appTooltip class="truncate">
                          {{property.street + ' ' + (property.house_number ?? '')}}
                      </p>
                      <p matTooltip="{{property.zip + ' ' + property.town}}" appTooltip class="truncate">
                          {{property.zip + ' ' + property.town}}
                      </p>
                  </div>

                  <div class="mb-2 mt-3">
                      <circle-progress *ngIf="hasPropertyStatistics(property)"
                                       subtitle="{{progress(property) |number: '1.0-2':'de'}}%"
                                       [percent]="progress(property)"
                                       [backgroundStrokeWidth]=0
                                       [backgroundPadding]=5
                                       [radius]=45
                                       [space]=-2
                                       [outerStrokeWidth]=3
                                       [outerStrokeColor]="'#73B1D6'"
                                       [outerStrokeLinecap]="'butt'"
                                       [innerStrokeColor]="'#f7f7f7'"
                                       [innerStrokeWidth]=3
                                       [subtitleColor]="'#35566E'"
                                       [titleFontWeight]="'900'"
                                       [subtitleFontSize]="'19'"
                                       [animateTitle]=false
                                       [animationDuration]=1000
                                       [showTitle]=false
                                       [showUnits]=false
                                       [showBackground]=false
                                       [clockwise]=true
                                       [responsive]=false
                                       [startFromZero]=false
                                       [lazy]=true
                      ></circle-progress>
                      <div *ngIf="!hasPropertyStatistics(property)">
                          <ngx-skeleton-loader [theme]="{'width':'70px','height':'70px'}" appearance="circle"
                                               count="1"></ngx-skeleton-loader>
                      </div>
                  </div>

                  <div class="download is-flex is-justify-content-space-evenly is-align-items-center m-0"
                       (click)="hasDownloadPermissions() ? downloadNew(property, $event) : $event.stopPropagation()">
                    <p>Neue Dokumente herunterladen</p>
                    <div class="is-flex is-justify-content-center is-align-items-center h-0 ml-1">
                      <img class="download-icon" alt="Download Icon" src="assets/images/download_icon/download_icon_light.svg">
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <app-pagination (goTo)="onGoTo($event)"
                        (next)="onNext($event)"
                        (previous)="onPrevious($event)"
                        *ngIf="total > 1"
                        [current]="current"
                        [total]="total"
        ></app-pagination>

      </div>
      <div class="column is-2"></div>
    </div>
  </ng-container>
  <ng-template #noPermissions>

  </ng-template>
</div>
